import { ACTIONS } from "./Actions";

const reducers = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_PUBLIC_PHENOMENA_GROUPS:
      return {
        ...state,
        publicPhenomenaGroups: action.payload,
      };
    default:
      return state;
  }
};

export default reducers;
